import { render } from "./SectionAccountProfile.vue?vue&type=template&id=f88a67a6&scoped=true"
import script from "./SectionAccountProfile.vue?vue&type=script&lang=js"
export * from "./SectionAccountProfile.vue?vue&type=script&lang=js"

import "./SectionAccountProfile.vue?vue&type=style&index=0&id=f88a67a6&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f88a67a6"]])

export default __exports__